import { useCallback, useMemo } from "react";
import type { Maybe, SurveyQuestion } from "gql/generated";
import {
  parseAddressSearchResponse,
  serializeAddressSearchResponse,
} from "./addressSearchResponse";
import { AddressSearchField } from "./AddressSearchField";

type AddressSearchInputProps = {
  question: SurveyQuestion;
  questionName: string;
  response: string[] | Maybe<string>[];
  onResponseChange: (questionId: string, response: string[]) => void;
};

export const AddressSearchInput = ({
  question,
  questionName,
  response,
  onResponseChange,
}: AddressSearchInputProps) => {
  const parsedResponse = useMemo(
    () => parseAddressSearchResponse(response),
    [response],
  );

  const handleChange = useCallback(
    (value: NonNullable<ReturnType<typeof parseAddressSearchResponse>> | null) => {
      if (!value) {
        onResponseChange(question._id, []);
        return;
      }
      onResponseChange(question._id, serializeAddressSearchResponse(value));
    },
    [onResponseChange, question._id],
  );

  return (
    <AddressSearchField
      label={questionName}
      value={parsedResponse}
      onChange={handleChange}
      _labelProps={{
        visual: "bodyMedium",
        color: "text.dark",
        whiteSpace: "pre-wrap",
      }}
    />
  );
};
